import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HeaderNav.css";
import {
  FaYoutube,
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaGlobe,
  FaEnvelope
} from "react-icons/fa";

const HeaderNav = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState("en");

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  const socialLinks = [
    { icon: <FaYoutube />, link: "https://youtube.com/@lssftrust" },
    { icon: <FaFacebookF />, link: "https://www.facebook.com/lssftrust" },
    { icon: <FaInstagram />, link: "https://www.instagram.com/lssf_trust/" }
  ];

  return (
    <div className="header-nav">
      <div className="container-fluid custom-container">
        <div className="header-row">

          {/* Left */}
          <div className="left">
            <div className="item">
              <FaPhoneAlt />
              <span>+91-9319965799</span>
            </div>

            <div className="item hide-mobile">
              <FaGlobe />
              <span>lsstrust.org.in</span>
            </div>

            <div className="item hide-tablet">
              <FaEnvelope />
              <span>lssftrust@gmail.com</span>
            </div>
          </div>

          {/* Right */}
          <div className="right">

            {/* Social */}
            <div className="social">
              {socialLinks.map((s, i) => (
                <a key={i} href={s.link} target="_blank" rel="noreferrer">
                  {s.icon}
                </a>
              ))}
            </div>

            {/* Language Toggle */}
            <div className="lang-toggle">
              <button
                className={language === "en" ? "active" : ""}
                onClick={() => handleLanguageChange("en")}
              >
                EN
              </button>
              <button
                className={language === "hi" ? "active" : ""}
                onClick={() => handleLanguageChange("hi")}
              >
                हिन्दी
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderNav;